import { Subscription } from 'rxjs';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

export abstract class BaseComponent {

  private _sub: Subscription[] = [];
  private _loading: boolean = true;
  private _welcome: boolean = false;

  constructor(){
    EventSharedService.get('reloadId').emit();
  }

  /**
   * Adicionar uma Subscription a lista.
   *
   * @param sub
   */
  addSub(sub: Subscription): void { this._sub.push(sub); }

  /**
   * Realizar unsubscribe/dispose nos itens adicionados anteriomente a lista.
   */
  unsubscribeList(): void { this._sub.forEach(s => s.unsubscribe()); }

  /**
   * Início do carregamento. Este método é utilizado para um controle único de loading.
   */
  loading = (): void => { this._loading = true; }

  /**
   * Final do carregamento. Este método é utilizado para um controle único de loading.
   */
  loaded = (): void => { this._loading = false; }

  /**
   * Início da exibição do banner de bem-vindo. Este método é utilizado para um controle inicial do welcome.
   */
  welcome = (): void => { this._welcome = false; }

  /**
   * #######################
   * ## Getters e Setters ##
   * #######################
   */

  get isLoading() { return this._loading; }

  get isWelcome() { return this._welcome; }
}
